<script>
export default {
  props: ['formdata'],
  data() {
    return {
      img:null,
      base64img:null,
      localModel: {},
      initial:true,
    }
  },
  methods: {
    upload() {
      const files = document.getElementById("file").files;
      var _this = this
      for(const file of files) {
        const reader = new FileReader();
        reader.onloadend = () => {
          _this.localModel.inruilfoto = reader.result
          _this.localModel.inruilfotonaam = reader.fileName
          console.log(reader.fileName); // file name
        };
        reader.fileName = file.name;
        reader.readAsDataURL(file);
      }
      this.showsvg()

    },
    previousStep() {
      this.emitter.emit("step", 3);
    },
    nextStep() {
      if (this.validate()) {
        this.emitter.emit("modelUpdated", this.localModel);
        this.emitter.emit("step", 5);
      }

    },
    showsvg()
    {
      const svgElement = document.getElementById('mySvg');
      svgElement.classList.remove('d-none');
    },
    validate() {
      if (this.localModel.lookingfor === "" ||
          this.localModel.movable === ""
      )
        return false;
      return true;
    },
  },
  mounted() {
    this.localModel = this.formdata;


  }
}
</script>
<template>

  <!------------ step form Area Start  ----------->
  <section class="step-form">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="step-form-wrapper">
            <div class="contact-form">
              <form action="">
                <div class="step-form-content">
                  <form action="data.php" method="post" class="form">
                    <!-- Progress Bar -->
                    <div class="progress-bar">
                      <div class="progress" id="progress"></div>
                      <div class="progress-step active" data-title="Personal"></div>
                      <div class="progress-step active" data-title="Contact "></div>
                      <div class="progress-step active" data-title="Experiences"></div>
                      <div class="progress-step active" data-title="Links"></div>
                      <div class="progress-step" data-title="Links"></div>
                    </div>

                    <!-- Steps -->
                    <div class="form-step active">
                      <h3>Bedrijfsgegevens</h3>
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="row">
                            <div class="col-lg-12">
                              <div class="contact-form-info">
                                <label for="">o	Heeft u nog schaftwagens, schakelunits of directie- en schaftunits die u wilt inruilen?</label>
                                <div class="contact-form-wrapper">
                                  <div class="contact-form-check">
                                    <input class="contact-form-check-input" type="radio" :value="true" v-model="localModel.tradein" id="flexCheckChecked">
                                    <label class="contact-check-label" for="flexCheckChecked">
                                      Ja
                                    </label>
                                  </div>
                                  <div class="contact-form-check">
                                    <input class="contact-form-check-input" type="radio" :value="false" v-model="localModel.tradein" id="flexCheckChecked" checked>
                                    <label class="contact-check-label" for="flexCheckChecked">
                                      Nee
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" v-if="localModel.tradein === true">
                            <div class="col-lg-6">
                              <div class="contact-form-info">
                                <label for="">Hoeveel schaftwagens</label>
                                <input v-model="localModel.quantity" type="text" placeholder="Aantal">
                              </div>
                            </div>
                            <div class="col-lg-6">
                              <div class="contact-form-info">
                                <label for="">Hoeveel units</label>
                                <input v-model="localModel.units" type="text" placeholder="Aantal">
                              </div>
                            </div>
                          </div>
                          <div class="row" v-if="localModel.tradein === true">
                            <div class="col-lg-12">
                              <div class="single-upload">
                                <div class="single-upload-title">
                                  <h5>Foto <span>{{ localModel.inruilfotonaam ? ':':'' }} {{ localModel.inruilfotonaam ?? ''}}</span></h5>
                                </div>
                                <div class="upload-box">
                                  <div class="drop_box">
                                    <div class="opload-icon">
                                      <img src="assets/img/upload.svg" alt="">
                                    </div>
                                    <h4>Klik hier om uw bestand te kiezen (JPG, PNG, of PDF)</h4>
                                    <input type="file" id="file" @change="upload" ref="myUploader" style="display: none"  accept=".jpg,.jpeg,.png,.pdf" >
                                    <svg class="d-none" id="mySvg" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" width="48px" height="48px"><path fill="#c8e6c9" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"/><path fill="#4caf50" d="M34.586,14.586l-13.57,13.586l-5.602-5.586l-2.828,2.828l8.434,8.414l16.395-16.414L34.586,14.586z"/></svg>
                                    <button class="btn" @click.prevent="$refs.myUploader.click()"></button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="contact-form-btn contact-form-btn-two">
                  <button class="contact-form-btn-gray" @click.prevent="previousStep">Vorige</button>
                  <button @click.prevent="nextStep">Volgende</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!------------ step form Area End ------------->

</template>

<style scoped>

</style>